export default "__VITE_ASSET__Dqsh07t3__"